<template>
  <div
    class="pin-modal"
    v-if="isVisible"
    @keydown="handleKeyPress"
    ref="modalContainer"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h2>Unesi PIN</h2>
        <button class="close-button" @click="closeModal">X</button>
      </div>
      <div class="pin-display-container">
        <div class="pin-display">{{ maskedPin }}</div>
      </div>
      <div class="buttons">
        <button
          v-for="n in [1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :key="n"
          @click="addNumber(n)"
          @touchstart="buttonTouchStart($event, n)"
          @touchend="buttonTouchEnd($event, n)"
          class="number-button"
          :class="{ 'button-pressed': pressedButton === n }"
          ref="numberButtons"
        >
          {{ n }}
        </button>
        <button class="empty-button"></button>
        <button
          @click="addNumber(0)"
          @touchstart="buttonTouchStart($event, 0)"
          @touchend="buttonTouchEnd($event, 0)"
          class="number-button"
          :class="{ 'button-pressed': pressedButton === 0 }"
          ref="numberButtons"
        >
          0
        </button>
        <button class="empty-button"></button>
      </div>
      <button @click="clearPin" class="clear-button">Očisti</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PinModal',
  data () {
    return {
      currentPin: '',
      isVisible: false,
      pressedButton: null
    }
  },
  computed: {
    maskedPin () {
      return '*'.repeat(this.currentPin.length)
    }
  },
  methods: {
    addNumber (number) {
      if (this.currentPin.length < 4) {
        this.currentPin += number
        if (this.currentPin.length === 4) {
          this.submitPin()
        }
      }
    },
    submitPin () {
      if (this.validatePin()) {
        this.$emit('pin-submitted', this.currentPin)
        this.closeModal()
      } else {
        this.clearPin()
      }
    },
    validatePin () {
      // Replace this with your actual PIN validation logic
      // For example, you might check against a list of valid PINs
      // or make an API call to verify the PIN.
      // For this example, we'll just return true (valid) for any PIN.
      return true
    },
    clearPin () {
      this.currentPin = ''
    },
    openModal () {
      this.isVisible = true
      this.clearPin()
      this.$nextTick(() => {
        this.$refs.modalContainer.focus()
        // Focus on the buttons so i can use keyboard without mouse
        try {
          this.$refs.numberButtons.focus()
        } catch (error) {
          console.log('error', error)
        }
      })
    },
    closeModal () {
      this.isVisible = false
    },
    buttonTouchStart (event, number) {
      event.preventDefault()
      this.pressedButton = number
      this.addNumber(number)
    },
    buttonTouchEnd (event, number) {
      event.preventDefault()
      this.pressedButton = null
    },
    handleKeyPress (event) {
      const key = event.key
      if (key >= '0' && key <= '9') {
        this.addNumber(parseInt(key))
      } else if (key === 'Backspace') {
        this.clearPin()
      } else if (key === 'Enter') {
        if (this.currentPin.length === 4) {
          this.submitPin()
        }
      } else if (key === 'Escape') {
        this.closeModal()
      }
    }
  }
}
</script>

  <style scoped>
.pin-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  outline: none; /* Remove the default focus outline */
}

.modal-content {
  background-color: white;
  padding: 30px;
  border-radius: 5px;
  text-align: center;
  width: 400px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
}

.pin-display-container {
  height: 30px;
  overflow: hidden;
  margin-bottom: 20px;
}

.pin-display {
  font-size: 48px;
  letter-spacing: 10px;
  line-height: 48px;
}

.buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.number-button {
  padding: 20px;
  font-size: 32px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.1s ease-in-out;
  font-weight: 900;
  outline: none;
}

.number-button:active,
.button-pressed {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  transform: translateY(2px);
}

.clear-button {
  background-color: #d01e2b;
  color: white;
  padding: 15px 25px;
  font-size: 28px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.1s ease-in-out;
  font-weight: 900;
}

.clear-button:active {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  transform: translateY(2px);
}

.empty-button {
  border: none;
  background-color: transparent;
  cursor: default;
}
</style>
